
import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  poLoadedData = [];
  invoiceLoadedData = [];
  GRNLoadedData = [];
  receiptLoadedData = [];

  VendorPortalpoLoadedData = [];
  VendorPortalinvoiceLoadedData = [];
  VendorPortalGRNLoadedData = [];
  VendorPortalreceiptLoadedData = [];

  // all invoices paagination variables
  allPaginationFirst = 0;
  allPaginationRowLength = 10;
  poPaginationFirst = 0;
  poPaginationRowLength = 10;
  GRNPaginationFirst = 0;
  GRNPaginationRowLength = 10;
  paymentPaginationFisrt = 0;
  paymentPaginationRowLength = 10;
  archivedPaginationFirst = 0;
  archivedPaginationRowLength = 10;
  rejectedPaginationFirst = 0;
  rejectedPaginationRowLength = 10;
  servicePaginationFirst = 0;
  servicePaginationRowLength = 10;

  invTabPageNumber: number = 1;
  poTabPageNumber: number = 1;
  arcTabPageNumber: number = 1;
  rejTabPageNumber: number = 1;
  grnTabPageNumber: number = 1;
  serviceTabPageNumber: number = 1;
  excTabPageNumber: number = 1;
  crGRNTabPageNumber: number = 1;
  aprTabPageNumber: number = 1;

  // Edited page pagination variables
  editInvoicesPaginationFisrt = 0;
  editInvoicesPaginationRowLength = 10;
  inProgressPaginationFisrt = 0;
  inProgressPaginationRowLength = 10;
  tobeApprovedPaginationFisrt = 0;
  tobeApprovedPaginationRowLength = 10;

  // Finance approval page pagination variables
  financePaginationFisrt = 0;
  financePaginationRowLength = 10;

  // vendor page
  vendorPaginationFirst = 0;
  vendorPaginationRowLength = 10;

  // serviceProvider page
  SPPaginationFirst = 0;
  SPPaginationRowLength = 10;
  updateColumns: any[];
  invoiceColumns: any[];
  columnstodisplayInvoice: any[];
  allColumns: any[];


  bgColorCode = [
    { id: 0, sub_id: 0, name: 'All', bgcolor: 'inherit', textColor: '#F3BC45' },
    { id: 1, sub_id: 1, name: 'System Check In - Progress', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 2, sub_id: 2, name: 'Processing Document', bgcolor: 'inherit', textColor: '#358DC0' },
    { id: 3, sub_id: 3, name: 'Finance Approval Completed', bgcolor: 'inherit', textColor: '#14BB12' },
    { id: 4, sub_id: 4, name: 'Need To Review', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 4, sub_id: 4, name: 'Under Review', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 4, sub_id: 35, name: 'Waiting For GRN Creation', bgcolor: 'inherit', textColor: '#358DC0' },
    { id: 4, sub_id: 39, name: 'GRN Created in Serina', bgcolor: 'inherit', textColor: '#14BB12' },
    { id: 4, sub_id: 100, name: 'GRN Attachment not Found', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 5, sub_id: 5, name: 'Edit in Progress', bgcolor: 'inherit', textColor: '#358DC0' },
    { id: 6, sub_id: 6, name: 'Awaiting Edit Approval', bgcolor: 'inherit', textColor: '#358DC0' },
    { id: 7, sub_id: 7, name: 'Sent to ERP', bgcolor: 'inherit', textColor: '#14BB12' },
    { id: 8, sub_id: 8, name: 'Payment Cleared', bgcolor: 'inherit', textColor: '#14BB12' },
    { id: 9, sub_id: 9, name: 'Payment Partially Paid', bgcolor: 'inherit', textColor: '#358DC0' },
    { id: 10, sub_id: 10, name: 'Invoice Rejected', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 11, sub_id: 11, name: 'Payment Rejected', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 12, sub_id: 12, name: 'PO Open', bgcolor: 'inherit', textColor: '#14bb12' },
    { id: 13, sub_id: 13, name: 'PO Closed', bgcolor: 'inherit', textColor: '#B2B2B2' },
    { id: 16, sub_id: 16, name: 'ERP Exception', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 15, sub_id: 15, name: 'Mismatch value/s', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 14, sub_id: 14, name: 'Posted In ERP', bgcolor: 'inherit', textColor: '#14BB12' },
    { id: 24, sub_id: 70, name: 'Set Approval', bgcolor: 'inherit', textColor: '#358DC0' },
    { id: 2, sub_id: 37, name: 'GRN successfully created in ERP', bgcolor: 'inherit', textColor: '#14BB12' },
    { id: 3, sub_id: 70, name: 'Approval Pending', bgcolor: 'inherit', textColor: '#358DC0' },
    { id: 4, sub_id: 81, name: 'GRN Approval Pending', bgcolor: 'inherit', textColor: '#358DC0' },
    { id: 27, sub_id: 23, name: 'Duplicate Invoice', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 29, sub_id: 23, name: 'Mail Queue', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 30, sub_id: 23, name: 'PO Cancelled', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 31, sub_id: 1000, name: 'Draft', bgcolor: 'inherit', textColor: '#14BB12' },
    { id: 32, sub_id: 1002, name: 'Pending Approval', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 33, sub_id: 1003, name: 'Approved', bgcolor: 'inherit', textColor: '#14BB12' },
    { id: 34, sub_id: 1004, name: 'Rejected', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 35, sub_id: 1005, name: 'Cancelled', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 36, sub_id: 1006, name: 'Posted', bgcolor: 'inherit', textColor: '#14BB12' },
    { id: 37, sub_id: 1007, name: 'Paid', bgcolor: 'inherit', textColor: '#14BB12' },
    { id: 38, sub_id: 1008, name: 'Not Paid', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 39, sub_id: 1009, name: 'Partially Paid', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 40, sub_id: 1010, name: 'Workflow Failure', bgcolor: 'inherit', textColor: '#F1932F' },
    { id: 41, sub_id: 1011, name: 'Attachment Missed', bgcolor: 'inherit', textColor: '#F1932F' },

  ]

  // bgColorCode = [
  //   { id:0, sub_id:0, name :'All', bgcolor: '#FEF9EC', textColor :'#000000',icon:''},
  //   { id:1,sub_id:1, name :'System Check In - Progress', bgcolor: '#EA4335', textColor :'#000000',icon:'assets/Serina Assets/Group 29.png'},
  //   { id:2, sub_id:2,name :'Processing Document', bgcolor: '#F19B44', textColor :'#000000',icon:'assets/Serina Assets/Group 28.png'},
  //   { id:3, sub_id:3,name :'Finance Approval Completed', bgcolor: '#E0FFEF', textColor :'#000000',icon:'assets/Serina Assets/Group 26.png'},
  //   { id:4, sub_id:4, name :'Need To Review', bgcolor: '#FBBC05', textColor :'#000000',icon:'assets/Serina Assets/Group 27.png'},
  //   { id:4, sub_id:35, name :'Ready for GRN creation', bgcolor: '#8EB719', textColor :'#000000',icon:'assets/Serina Assets/Group 69.png'},
  //   { id:4, sub_id:39, name :'GRN Created in serina', bgcolor: '#8F00FF', textColor :'#000000',icon:'assets/Serina Assets/Group 62.png'},
  //   { id:5, sub_id:5,name :'Edit in Progress', bgcolor: '#FFE8FD', textColor :'#AE5BA7',icon:'assets/Serina Assets/Group 26.png'},
  //   { id:6,sub_id:6, name :'Awaiting Edit Approval', bgcolor: '#F7FFC8', textColor :'#8EA01F',icon:'assets/Serina Assets/Group 26.png'},
  //   { id:7,sub_id:7, name :'Sent to ERP', bgcolor: '#5ABB74', textColor :'##000000',icon:'assets/Serina Assets/Group 26.png'},
  //   { id:8, sub_id:8,name :'Payment Cleared', bgcolor: '#ECF9ED', textColor :'#3EB948',icon:'assets/Serina Assets/Group 26.png'},
  //   { id:9, sub_id:9,name :'Payment Partially Paid', bgcolor: '#F1EBFF', textColor :'#6A5894',icon:'assets/Serina Assets/Group 26.png'},
  //   { id:10, sub_id:10,name :'Invoice Rejected', bgcolor: '#FFE8E8', textColor :'#FF3C3C',icon:'assets/Serina Assets/Group 26.png'},
  //   { id:11, sub_id:11,name :'Payment Rejected', bgcolor: '#FFE8E8', textColor :'#FF3C3C',icon:'assets/Serina Assets/Group 26.png'},
  //   { id:12, sub_id:12,name :'PO Open', bgcolor: '#ffffff', textColor :'#000000',icon:'assets/Serina Assets/Group 43.png'},
  //   { id:13, sub_id:13,name :'PO Closed', bgcolor: '#ffffff', textColor :'#000000',icon:'assets/Serina Assets/Group 51.png'},
  //   { id:16, sub_id:16,name :'ERP Exception', bgcolor: '#fff3e0', textColor :'#b7925b',icon:'assets/Serina Assets/Group 26.png'},
  //   { id:15, sub_id:15,name :'Mismatch value/s', bgcolor: '#ddebc5', textColor :'#818549',icon:'assets/Serina Assets/Group 26.png'},
  //   { id:14, sub_id:14,name :'Posted In ERP', bgcolor: '#d0fbdd', textColor :'#14bb12',icon:'assets/Serina Assets/Group 26.png'},
  // ]
  serviceinvoiceLoadedData = [];
  approvalServicePaginationRowLength = 10;
  approvalServicePaginationFirst = 0;
  approvalVendorPaginationFirst = 0;
  approvalVendorPaginationRowLength = 10;
  exc_batch_edit_page_first = 0;
  exc_batch_edit_page_row_length = 10;
  exc_service_batch_edit_page_first = 0;
  exc_service_batch_edit_page_row_length = 10;
  exc_batch_approve_page_first = 0;
  exc_batch_approve_page_row_length = 10;
  entityData = new BehaviorSubject<any>([]);
  VendorsReadData = new BehaviorSubject<any>([]);
  NonPOvendorPaginationFirst = 0;
  NonPOvendorPaginationRowLength = 10;
  entityID: any;
  editableInvoiceData: any;
  vendorNameList = new BehaviorSubject<any>([]);
  vendorsListData = [];
  offsetCount = 1;
  pageCountVariable: number = 0;
  POtableLength: any;
  GRNTableLength: any;
  archivedDisplayData = [];
  ARCTableLength: any;
  rejectedDisplayData = [];
  rejectTableLength: number;
  GRNExceptionPaginationFisrt = 0;
  GRNExceptionPaginationRowLength = 10;
  GRNExcpDispalyData = [];
  GRNExcpTableLength: number;
  reUploadData: any;
  create_GRN_page_first = 0;
  create_GRN_page_row_length = 10;
  searchTextException: any;
  configData: any;
  subStatusId: number;

  rejectReason = [
    { id: 1, reason: 'Invoice already posted in Dynamics, no action required' },
    { id: 2, reason: 'Item Descriptions do not match LPO, please correct invoice & re-upload' },
    { id: 3, reason: 'Invoice Quantities do not match LPO, please correct invoice & re-upload' },
    { id: 4, reason: 'Invoice Price do not match LPO, please correct invoice & re-upload' },
    { id: 5, reason: 'Uploaded under wrong Entity, please re-upload under correct entity' },
    { id: 6, reason: 'Incorrect details on Invoice (LPO No, date, vendor name, TRN, etc..) , please correct invoice & re-upload' },
    { id: 7, reason: 'Multiple invoices uploaded, please upload invoice separately' },
    { id: 8, reason: 'PO is closed or fully booked.' },
    { id: 9, reason: 'Missing Supporting Documents – Kindly re-upload the invoice with the stamped Delivery Note and LPO.' },
    { id: 10, reason: 'Missing Supporting Documents – Kindly re-upload the invoice with the stamped Work Completion Report or Service Report and LPO.' },
    { id: 9, reason: 'Others' }
  ]
  invoiceGlobe = '';
  serviceGlobe = '';
  exception_G_S = '';
  exception_service_G_S = '';
  exception_status = '';
  exception_status_service = '';
  exception_A_G_S = '';
  createGrn_G_S = '';

  offsetCountPO = 1;
  pageCountVariablePO = 0;
  offsetCountGRN = 1;
  pageCountVariableGRN = 0;
  offsetCountArc = 1;
  pageCountVariableArc = 0;
  offsetCountRej = 1;
  pageCountVariableRej = 0;

  searchPOStr = '';
  searchGRNStr = '';
  searchArcStr = '';
  searchRejStr = '';
  portalName: string;
  isAdmin: boolean;
  ipAddress: string;
  grnWithPOBoolean: boolean;
  GRN_PO_Data = [];
  idDocumentType: number;
  documentType: string;
  ap_boolean: any;
  doc_status_tab: any;
  searchSOStr = '';
  SODisplayData = [];
  soArrayLength: any;
  SOPaginationFirst = 1;
  SOPaginationRowLength = 10;
  offsetCountSO = 1;
  pageCountVariableSO = 0;
  poLineData = [];
  arenaMasterData: any;
  isDesktop: boolean;
  vendorId: any;
  posted_inv_type = '';
  invTabColumns: any;
  poTabColumns: any;
  arcTabColumns: any;
  serTabColumns: any;

  exceptionService_G_S: string;
  vendor_exc_status = { id: 0, name: 'All' };
  service_exc_status = { id: 0, name: 'All' };
  vendor_exc_uniSearch: string = '';
  service_exc_uniSearch: string = '';
  grn_exc_uniSearch: string = '';
  masterTabName: string;
  masterSubTabName = 'invoice';
  grn_aprve_uniSearch: string = '';
  snackBarRef: any;
  isTableView = new BehaviorSubject<boolean>(true);
  approvalPageNumber: any;
  approval_uniSearch: any;
  approvalPageNumberSP: any;
  SP_aprve_uniSearch: string = '';
  statusId: any;
  isMobile: boolean;
  projectIdArr: any;
  projectCArr: any;
  ent_code: any;
  isCoordinator: boolean;
  grn_manpower_metadata: any;
  added_manpower_data: any[];
  number_of_days: number;
  manpower_saved_date_range: Date[];
  isEditGRN: boolean;
  po_lines: any;
  manpowerResponse: { dates: { startdate: string; enddate: string; }; data: any[]; };
  serviceStatus: any;
  invoiceStatus: any;
  isServiceLive: boolean = true;
  private previousUrl: string | null = null;
  private currentUrl: string | null = null;
  apiVersion: string;
  buildVersion: string;
  invoiceNumber: any;
  onboardedData: any[] = [];
  exceptionByUserBool: boolean = true;
  emaarTaxGroup = [
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDc5NzsxLDU2MzcxNDQ4MDQn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "EXP",
      "TaxCode": "EXP",
      "ReverseCharge_W": "No",
      "TaxValue": 0,
      "TaxExemptCode": "EXP",
      "DataAreaId1": "dbd",
      "ExemptTax": "Yes",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEzMDA1NzI2NDAsNTYzNzE0NDc5ODsxLDU2MzcxNDQ4MDUn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "EXS",
      "TaxCode": "EXS",
      "ReverseCharge_W": "No",
      "TaxValue": 0,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDc5OTsxLDU2MzcxNDQ4MDYn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "ICS",
      "TaxCode": "ICS",
      "ReverseCharge_W": "No",
      "TaxValue": 0,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgwMDsxLDU2MzcxNDQ4MDcn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "OSP",
      "TaxCode": "OSP",
      "ReverseCharge_W": "No",
      "TaxValue": 0,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgwMTsxLDU2MzcxNDQ4MDgn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "OSS",
      "TaxCode": "OSS",
      "ReverseCharge_W": "No",
      "TaxValue": 0,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgwMjsxLDU2MzcxNDQ4MDkn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "RCMG",
      "TaxCode": "RCMG",
      "ReverseCharge_W": "No",
      "TaxValue": 5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzU4NjY4MjIzOSw1NjM3MTQ0ODAzOzEsNTYzNzE0NDgxMCc=\"",
      "dataAreaId": "dbd",
      "TaxGroup": "RCMG",
      "TaxCode": "RCMG-R",
      "ReverseCharge_W": "Yes",
      "TaxValue": -5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgwNDsxLDU2MzcxNDQ4MTEn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "RCMS",
      "TaxCode": "RCMS",
      "ReverseCharge_W": "No",
      "TaxValue": 5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzE0MTE0MDA1MzAsNTYzNzE0NDgwNTsxLDU2MzcxNDQ4MTIn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "RCMS",
      "TaxCode": "RCMS-R",
      "ReverseCharge_W": "Yes",
      "TaxValue": -5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgwNjsxLDU2MzcxNDQ4MTMn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "SRP",
      "TaxCode": "SRP",
      "ReverseCharge_W": "No",
      "TaxValue": 5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgwNzsxLDU2MzcxNDQ4MTQn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "SRSAJM",
      "TaxCode": "SRSAJM",
      "ReverseCharge_W": "No",
      "TaxValue": 5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgwODsxLDU2MzcxNDQ4MTUn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "SRSAUH",
      "TaxCode": "SRSAUH",
      "ReverseCharge_W": "No",
      "TaxValue": 5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgwOTsxLDU2MzcxNDQ4MTYn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "SRSDXB",
      "TaxCode": "SRSDXB",
      "ReverseCharge_W": "No",
      "TaxValue": 5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgxMDsxLDU2MzcxNDQ4MTcn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "SRSFUJ",
      "TaxCode": "SRSFUJ",
      "ReverseCharge_W": "No",
      "TaxValue": 5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgxMTsxLDU2MzcxNDQ4MTgn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "SRSHJ",
      "TaxCode": "SRSHJ",
      "ReverseCharge_W": "No",
      "TaxValue": 5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgxMjsxLDU2MzcxNDQ4MTkn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "SRSRAK",
      "TaxCode": "SRSRAK",
      "ReverseCharge_W": "No",
      "TaxValue": 5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgxMzsxLDU2MzcxNDQ4MjAn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "SRSUAQ",
      "TaxCode": "SRSUAQ",
      "ReverseCharge_W": "No",
      "TaxValue": 5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgxNDsxLDU2MzcxNDQ4MjEn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "TRPTS",
      "TaxCode": "TRPTS",
      "ReverseCharge_W": "No",
      "TaxValue": 5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgxNTsxLDU2MzcxNDQ4MjIn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "ZRP",
      "TaxCode": "ZRP",
      "ReverseCharge_W": "No",
      "TaxValue": 0,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NDgxNjsxLDU2MzcxNDQ4MjMn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "ZRS",
      "TaxCode": "ZRS",
      "ReverseCharge_W": "No",
      "TaxValue": 0,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    },
    {
      "@odata.etag": "W/\"JzEsNTYzNzE0NjA4NjsxLDU2MzcxNDYwODYn\"",
      "dataAreaId": "dbd",
      "TaxGroup": "IGS",
      "TaxCode": "IGS",
      "ReverseCharge_W": "No",
      "TaxValue": 5,
      "TaxExemptCode": "",
      "DataAreaId1": "dbd",
      "ExemptTax": "No",
      "ModifiedDateTime1": "2023-05-19T20:29:42Z",
      "IntracomVAT": "No",
      "UseTax": "No",
      "CreatedDateTime1": "2023-05-19T20:29:42Z"
    }
  ]
  statusInfo: any[] = [
    {
      "status": "Sent to ERP",
      "owner": "Serina System",
      "action": "No action required",
      "description": "Invoice successfully sent to ERP",
      "idstatus": 1,
      "isCustomerStatus": "0"
    },
    {
      "status": "System Check In - Progress",
      "owner": "Serina System",
      "action": "Wait for completion or monitor status",
      "description": "Document is under validation checks",
      "idstatus": 2,
      "isCustomerStatus": "0"
    },
    {
      "status": "Need To Review",
      "owner": "AP Team",
      "action": "Review invoice and update status",
      "description": "Invoice needs manual validation(or display the sub status)",
      "idstatus": 3,
      "isCustomerStatus": "0"
    },
    {
      "status": "Waiting For GRN Creation",
      "owner": "Receiving Team",
      "action": "Coordinate with Receivers/Procurement to create GRN",
      "description": "GRN not yet created for matched PO",
      "idstatus": 4,
      "isCustomerStatus": "0"
    },
    {
      "status": "Attachment Missed",
      "owner": "Serina System",
      "action": "Upload the missing document",
      "description": "Invoice is missing required attachment",
      "idstatus": 5,
      "isCustomerStatus": "1"
    },
    {
      "status": "Draft",
      "owner": "Serina System",
      "action": "Submit invoice for approval",
      "description": "Invoice is saved but not submitted for approval",
      "idstatus": 6,
      "isCustomerStatus": "1"
    },
    {
      "status": "Pending Approval",
      "owner": "Requestor",
      "action": "Follow up with approver",
      "description": "Invoice is waiting for approval",
      "idstatus": 7,
      "isCustomerStatus": "1"
    },
    {
      "status": "Overdelivery Limit",
      "owner": "Procurement",
      "action": "Validate delivery and revise PO if needed",
      "description": "Delivered quantity exceeds PO limit",
      "idstatus": 8,
      "isCustomerStatus": "1"
    },
    {
      "status": "Budget Exceeded",
      "owner": "AP Team",
      "action": "Raise a budget request or reallocate budget",
      "description": "Invoice amount exceeds available budget",
      "idstatus": 9,
      "isCustomerStatus": "1"
    },
    {
      "status": "Workflow Failure",
      "owner": "IT Support/AP Team/Serina System",
      "action": "Re-initiate or correct workflow",
      "description": "Approval workflow did not complete",
      "idstatus": 10,
      "isCustomerStatus": "1"
    },
    {
      "status": "PO Not Confirmed",
      "owner": "Procurement Team",
      "action": "Coordinate with procurement to confirm PO, Click SUBMIT for PO Confirmation",
      "description": "PO is not yet confirmed in ERP",
      "idstatus": 11,
      "isCustomerStatus": "1"
    },
    {
      "status": "No Posting Lines",
      "owner": "Serina System",
      "action": "Review invoice coding and GL entries",
      "description": "No valid GL/posting lines found",
      "idstatus": 12,
      "isCustomerStatus": "1"
    },
    {
      "status": "Fiscal Period Closed",
      "owner": "AP Team",
      "action": "Change invoice date or reopen period",
      "description": "Invoice dated in a closed fiscal period",
      "idstatus": 13,
      "isCustomerStatus": "1"
    },
    {
      "status": "Missing Ledger Account",
      "owner": "AP Team",
      "action": "Update configuration or ledger mapping",
      "description": "GL account not mapped or invalid",
      "idstatus": 14,
      "isCustomerStatus": "1"
    },
    {
      "status": "Duplicate Invoice Lines",
      "owner": "Serina System",
      "action": "Remove or merge duplicate lines",
      "description": "Duplicate line items found",
      "idstatus": 15,
      "isCustomerStatus": "1"
    },
    {
      "status": "Inventory Issue",
      "owner": "Receiving Team",
      "action": "Resolve inventory discrepancy",
      "description": "Stock mismatch or issue in GRN validation",
      "idstatus": 16,
      "isCustomerStatus": "1"
    },
    {
      "status": "Rounding Error",
      "owner": "AP Team",
      "action": "Adjust value or accept variation in ERP and proceed.",
      "description": "Minor amount mismatch due to rounding",
      "idstatus": 17,
      "isCustomerStatus": "1"
    },
    {
      "status": "Invoice Total Mismatch",
      "owner": "Vendor/AP Team",
      "action": "Verify and correct invoice values",
      "description": "Invoice header and lines total mismatch",
      "idstatus": 18,
      "isCustomerStatus": "0"
    },
    {
      "status": "In Sufficient PO Balance",
      "owner": "Procurement",
      "action": "Revise PO or reject invoice",
      "description": "PO balance is not enough for invoice",
      "idstatus": 19,
      "isCustomerStatus": "0"
    },
    {
      "status": "Unit Price Mismatch",
      "owner": "Procurement",
      "action": "Validate and clarify with vendor",
      "description": "Line item unit price differs from PO",
      "idstatus": 20,
      "isCustomerStatus": "0"
    },
    {
      "status": "GRN Total Mismatch",
      "owner": "Receiving Team",
      "action": "Validate quantity/price mismatch",
      "description": "GRNQty doesn’t' match with Invoice Qty",
      "idstatus": 21,
      "isCustomerStatus": "0"
    },
    {
      "status": "Unmapped GRN",
      "owner": "Receiving Team",
      "action": "Map GRN manually or investigate",
      "description": "GRN exists but not linked to invoice/PO",
      "idstatus": 22,
      "isCustomerStatus": "0"
    },
    {
      "status": "Manually Created - Draft",
      "owner": "AP Team",
      "action": "Complete data and submit",
      "description": "Invoice manually entered and saved",
      "idstatus": 23,
      "isCustomerStatus": "1"
    },
    {
      "status": "PO not Found",
      "owner": "Serina System",
      "action": "Check PO reference and update",
      "description": "PO number not valid or not in system",
      "idstatus": 24,
      "isCustomerStatus": "0"
    },
    {
      "status": "OCR Error Found",
      "owner": "Serina System",
      "action": "Manually enter missing data",
      "description": "OCR failed to extract some fields",
      "idstatus": 25,
      "isCustomerStatus": "0"
    },
    {
      "status": "Server Issue",
      "owner": "Serina System",
      "action": "Retry later or contact Serina Help Desk",
      "description": "Backend system issue or timeout",
      "idstatus": 26,
      "isCustomerStatus": "0"
    },
    {
      "status": "PO Line Mismatch",
      "owner": "Procurement",
      "action": "Review invoice and reconcile with PO",
      "description": "Invoice has more lines than PO",
      "idstatus": 27,
      "isCustomerStatus": "0"
    },
    {
      "status": "posted",
      "owner": "Serina System",
      "action": "No action required",
      "description": "Invoice successfully posted to ERP",
      "idstatus": 28,
      "isCustomerStatus": "0"
    },
    {
      "status": "failure",
      "owner": "Serina System",
      "action": "Check logs and retry or escalate",
      "description": "Generic failure occurred",
      "idstatus": 29,
      "isCustomerStatus": "1"
    },
    {
      "status": "ERP Exception",
      "owner": "Serina System",
      "action": "Investigate and fix ERP-related error",
      "description": "ERP returned a failure status again",
      "idstatus": 30,
      "isCustomerStatus": "0"
    },
    {
      "status": "OCR Error in Extracted Fields",
      "owner": "Serina System",
      "action": "Manually verify and correct fields",
      "description": "Field data extracted incorrectly by OCR",
      "idstatus": 31,
      "isCustomerStatus": "0"
    },
    {
      "status": "success",
      "owner": "Serina System",
      "action": "No action required",
      "description": "Invoice processed successfully",
      "idstatus": 32,
      "isCustomerStatus": "0"
    },
    {
      "status": "PO Not Found",
      "owner": "Procurement Team",
      "action": "Confirm PO with vendor or buyer",
      "description": "PO not found in ERP",
      "idstatus": 33,
      "isCustomerStatus": "0"
    }
  ];
  statusChartData: any[];
  poData: any;
  vendor_exc_requestor: any;
  vendor_exc_owner: any;
  currentFiltersCreateGRN = {
    searchText: '',
    requestors: [],
    departments: []
  };


  constructor(private router: Router) {
    this.currentUrl = this.router.url;

    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      });
    console.log(this.grn_exc_uniSearch);
  }

  public getPreviousUrl(): string | null {
    return this.previousUrl;
  }

  getEntity(): Observable<any> {
    return this.entityData.asObservable();
  }

  getVendorsData(): Observable<any> {
    return this.VendorsReadData.asObservable();
  }

  // displayMode(){
  //   return this.isTableView.asObservable();
  // }

  getVendorNamesData(): Observable<any> {
    return this.vendorNameList.asObservable();
  }
  closeSnackbar(): void {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    }
  }

  searchFilter(searchTxt, filter_data) {
    return filter_data?.filter(item => {
      // Iterate over object keys
      for (const key in item) {
        if (Object?.prototype?.hasOwnProperty?.call(item, key)) {
          const value = item[key];
          // Check if the field value contains the search term
          if (value && (typeof value === 'string' || typeof value === 'number') && value?.toString()?.toLowerCase()?.includes(searchTxt?.toLowerCase())) {
            return true;
          }
        }
      }
      return false;
    });
  }

  changeTheme(primary: string, secondary: string) {
    document.documentElement.style.setProperty('--themeColor', primary);
    document.documentElement.style.setProperty('--textWColor', secondary);
  }

  uni_filter(list, label, event) {
    let filtered: any[] = [];
    let query = event.query;
    if (list?.length > 0) {
      for (let i = 0; i < list?.length; i++) {
        let item: any = list[i];
        if (item[label]?.toLowerCase().includes(query?.toLowerCase())) {
          filtered.push(item);
        }
      }
    }

    return filtered;
  }

  calculateAging(invoiceData): number | string {
    if (invoiceData?.aging_status) {
      return invoiceData.aging_status;
    }

    if (invoiceData?.CreatedOn) {
      const createdDate = new Date(invoiceData.CreatedOn);
      const today = new Date();
      const diffInTime = today.getTime() - createdDate.getTime();
      const diffInDays = Math.floor(diffInTime / (1000 * 3600 * 24));
      return diffInDays;
    }

    return 'N/A';
  }
}
